// removed by extract-text-webpack-plugin
module.exports = {"splitButtonContainer":"SplitButton__splitButtonContainer___2q-xb","selected":"SplitButton__selected___ss8ov","fullWidth":"SplitButton__fullWidth___EUujV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SplitButton/SplitButton.scss
// module id = 1198
// module chunks = 1